import { ReactElement } from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import Alert from '@mui/material/Alert/Alert';
import AlertTitle from '@mui/material/AlertTitle/AlertTitle';

export type severityType = 'error' | 'info' | 'warning' | 'success';

interface Props {
  message: string;
  title?: string;
  severity?: severityType;
  color?: severityType;
  onClose?: () => void;
  className?: string;
}

const useStyles = makeStyles(() => ({
  alert: {
    margin: '10px 0',
    borderRadius: '8px',
  },
}));

const _Alert = (props: Props): ReactElement => {
  const classes = useStyles();
  const { message, title, severity, onClose, color, className } = props;
  return (
    <Alert
      {...props}
      severity={severity}
      onClose={onClose}
      className={clsx(className, classes.alert)}
      title={title}
      color={color}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {message}
    </Alert>
  );
};

_Alert.defaultProps = {
  message: '',
  title: '',
  severity: 'success',
  color: 'success',
  onClose: () => {},
};

export default _Alert;
